module.exports = __webpack_public_path__ + "img/091b5a96cecdf155d22fef5ad3bbb051.png";